import React from "react"

// components
import ButtonPrimary from "components/ButtonPrimary"
import Modal from "components/Modal"

// styles
import styles from "./styles.module.scss"

const AddAgentModal = ({ agencies, error: incomingError, onSave, onClose }) => {
  return (
    <Modal>
      <div className={styles.decision}>
        <h4>Report Generator</h4>
        <p>Would you like to Start a Quick Report with all of the currently Executed Powers in the system, or just start with an Empty Report?</p>
        <p>This is just the first step.  You will have the ability to remove or add additional powers.</p>
        <div className={styles.decision__actions}>
          <ButtonPrimary color="grey" onClick={() => onClose()}>Cancel</ButtonPrimary>
          <ButtonPrimary color="navy" onClick={() => onSave('EMPTY_REPORT')}>Empty Report</ButtonPrimary>
          <ButtonPrimary color="navy" onClick={() => onSave('QUICK_REPORT')}>Start Quick</ButtonPrimary>
        </div>
      </div>
    </Modal>
  )
}

export default AddAgentModal
